import { useRef, useEffect } from "react";

export function useScrollIntoViewOnEdit(isEditing: boolean) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (!isEditing || !containerRef.current) return;
        const id = setTimeout(() => {
            containerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }, 50);
        return () => clearTimeout(id);
    }, [isEditing]);

    return containerRef;
}
